// PaymentAcknowledgement.js

import { Paper, Typography, Box, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const RoadAcknowledgement = ({
  applicationDetails,
  totalAmountPayable,
  applicationNumber,
  basePath
}) => {
  const navigate = useNavigate();

  return (
    <Paper sx={{ borderRadius: 2, boxShadow: 3 }}>
      <Typography variant="h4" sx={{ mb: 2, textAlign: 'center' }}>
        Payment Acknowledgement
      </Typography>
      <Typography>
        Hello <strong>{applicationDetails?.userName}</strong>,
      </Typography>
      
        <>
          <Typography sx={{ mt: 1 }}>
            Thank you for your payment of <strong>${totalAmountPayable}</strong> for
            Application# <strong>{applicationNumber}</strong>.
          </Typography>
          <Typography sx={{ mt: 1 }}>
            Please be advised that your request for a{' '}
            <strong>
              {'Road Opening'} Application
            </strong>{' '}
            has been received and is currently being reviewed by the Engineering
            Department.
          </Typography>
        </>
      
      <Typography sx={{ mt: 1 }}>
        If you have any further questions, please contact us at{' '}
        <a
          href={`mailto:${'RoadOpening'}@techgov.com`}
        >
          {'RoadOpening'}@techgov.com
        </a>
        .
      </Typography>
      <br />
      <Typography sx={{ mt: 1 }}>
        Thank you, <br />
        Engineering Dept.
      </Typography>
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Button
          variant="outlined"
          onClick={() => navigate(`${basePath}/application-list`)}
        >
          View My Applications
        </Button>
      </Box>
    </Paper>
  );
};

export default RoadAcknowledgement;
